import { useState, type MouseEvent } from 'react';
import { googleMapsUrl, wazeUrl } from '@shared/maps';
import type { Place } from '@shared/types';
import { appendEnglish } from '@shared/ptEn';
import { ActionMenu } from './ActionMenu';
import { GoogleMapsIcon, WazeIcon } from './Icons';

type PlaceRowNavProps = {
  place: Place;
};

function stopCardNav(e: MouseEvent) {
  e.stopPropagation();
}

function stopCardNavAndDefault(e: MouseEvent) {
  e.stopPropagation();
  e.preventDefault();
}

function onClusterClick(e: MouseEvent) {
  e.stopPropagation();
  if (e.target === e.currentTarget) e.preventDefault();
}

export function PlaceRowNav({ place }: PlaceRowNavProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="place-nav-icons" onClick={onClusterClick} onMouseDown={stopCardNav}>
        <a
          href={googleMapsUrl(place.address)}
          target="_blank"
          rel="noreferrer"
          aria-label={appendEnglish(`Directions to ${place.name} in Google Maps`, place.name)}
          onClick={stopCardNav}
          onMouseDown={stopCardNav}
        >
          <GoogleMapsIcon />
        </a>
        <a
          href={wazeUrl(place.lat, place.lng)}
          target="_blank"
          rel="noreferrer"
          aria-label={appendEnglish(`Directions to ${place.name} in Waze`, place.name)}
          onClick={stopCardNav}
          onMouseDown={stopCardNav}
        >
          <WazeIcon />
        </a>
        <button
          type="button"
          aria-label={appendEnglish(`More actions for ${place.name}`, place.name)}
          onClick={(e) => {
            stopCardNavAndDefault(e);
            setOpen(true);
          }}
          onMouseDown={stopCardNav}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden>
            <circle cx="5" cy="12" r="2" fill="currentColor" />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
            <circle cx="19" cy="12" r="2" fill="currentColor" />
          </svg>
        </button>
      </div>
      <ActionMenu place={place} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
